import { IframeQueryParameters } from '@wix/wix-chatbot-common/browser';
import { createPath } from 'history';
import { matchPath, matchRoutes } from 'react-router-dom';

import { getLast } from '../../util/guards';
import { AppRoutePatterns, appRoutes, routePathObjects } from './appRoutes';

export function trimBaseName(routerBaseName: string, url: string): string {
  return url.replace(routerBaseName, '');
}

export function getRouterBaseName(pathname: string): string {
  const pathItems = pathname.split('/').filter((path) => !!path);
  const widgetPathIndex = pathItems.findIndex((path) => path === 'widget');

  if (widgetPathIndex === -1) {
    return `/${pathItems[0] || ''}`;
  } else {
    return `/${pathItems.slice(0, widgetPathIndex + 1).join('/')}`;
  }
}

export const isRouteValid = (route: string): boolean => !!matchRoutes(routePathObjects, route);

export function getInitialEntries(history: string[], withoutHome = false): string[] {
  const startRouteFromUrl = getStartRouteFromUrl();
  if (withoutHome && startRouteFromUrl) {
    return [startRouteFromUrl];
  }

  const entries = withoutHome ? history.filter((url) => !matchPath(AppRoutePatterns.Home, url)) : history;
  const sanitizedHistory = entries.filter(
    (url, index) => !!matchRoutes(routePathObjects, url) && url !== entries[index - 1],
  );

  // First item in 'initialEntries' should always be Homepage(by design).
  const firstEntries = sanitizedHistory[0];
  if (!withoutHome && (!firstEntries || !matchPath(AppRoutePatterns.Home, firstEntries))) {
    sanitizedHistory.unshift(appRoutes.home());
  }

  const lastHistoryRoute = getLast(sanitizedHistory);

  if (startRouteFromUrl && startRouteFromUrl !== lastHistoryRoute) {
    sanitizedHistory.push(startRouteFromUrl);
  }

  return sanitizedHistory.length ? sanitizedHistory : [appRoutes.home()];
}

export function getStartRouteFromUrl(): string | undefined {
  const url = new URL(window.location.href);
  const applyUrlToRouter = url.searchParams.get(IframeQueryParameters.applyUrlToRouter);

  if (applyUrlToRouter !== null) {
    const { pathname, search, hash } = url;

    // we need to remove basename before using it in Router
    return trimBaseName(
      getRouterBaseName(pathname),
      // use only pathname and hash(for article anchors) to omit unnecessary query params for router(nodeId, suggestionId etc.)
      createPath({
        pathname,
        search,
        hash,
      }),
    );
  }
}
